module.exports = __webpack_public_path__ + "img/16.7232c7dd.png";